import { ApiDatafanAccountCredential } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "datafan.credential.info";

type Response = Await<ReturnType<typeof ApiDatafanAccountCredential.info>>;

export const useQueryDatafanCredentialInfo = (
  credentialId: number,
  options?: Omit<UseQueryOptions<Response>, "queryKey" | "queryFn">,
) =>
  useQuery(
    [KEY, credentialId],
    () => ApiDatafanAccountCredential.info(credentialId),
    options,
  );

useQueryDatafanCredentialInfo.KEY = KEY;
